import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { retryWhen, filter, map } from 'rxjs/operators';
import { infoCobro, cobroFacturas } from 'app/entities/info-grupo';
import { Observable } from 'rxjs';
import { UsuarioConLlamadas } from 'app/components/cartera/informes-cartera/gestionar-cartera/llamada';

@Injectable({
  providedIn: 'root'
})
export class InformesService {

  private infoGrupo_tipoFactura: string;

  constructor(private _http:HttpClient) {}

  /**
    * Se obtiene el informe de los tratamientos mas realizados en un rango
    * las fechas llegan por @fecha_inicio y @fecha_final
    * y al backend van por variables get las cuales se deben llamar @fechafinal y @fechainicial
    * Además debe recibir un parametro el cual dirá que informe se va a realizar
    * InformeTratamientos
   */
   public informeTratamientos(fecha_inicio, fecha_final) {

     return this._http.get(`${environment.backendUrl}/controllers/calidad_controller.php?fechainicial=${fecha_inicio}&fechafinal=${fecha_final}&accion=ProcedimientosMedicos`);
  }


  /**
   * InformacionProcedimientos
   */
  public informacionProcedimientos(fecha_inicio, fecha_final, procedimiento) {
    return this._http.get(`${environment.backendUrl}/controllers/calidad_controller.php?fechainicial=${fecha_inicio}&fechafinal=${fecha_final}&tratamiento_pro=${procedimiento}&accion=InformacionProcedimientos`);
  }


  public iassAudit(fechaIn,fechaFin){
    return this._http.get(`${environment.api}vital/iassAudit/${fechaIn}/${fechaFin}`)
  }
  /**
   * ApoyoUsuario
   */
  public ApoyoUsuariosBeneficiarios(fecha_inicio, fecha_final) {
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?fechainicial=${fecha_inicio}&fechafinal=${fecha_final}&accion=beneficiariosApoyo`);
  }

  /**
   * ApoyoUsuario_Beneficiarios
   */
  public ServiciosBeneficiarios(beneficiario_doc) {
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?bendoc=${beneficiario_doc}&accion=serviciosDeBeneficiario`);
  }

  public comprobarServicioDigital(consecutivo) {
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?consecutivo=${consecutivo}&accion=comprobarServicioDigital`);
  }

  public Bitacora(beneficiario_doc){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?bendoc=${beneficiario_doc}&accion=bitacoraBeneficiario`);
  }

  public InformacionContrato(fecha_inicio, fecha_final, titular) {
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?fechainicial=${fecha_inicio}&fechafinal=${fecha_final}&id_titular=${titular}&accion=titularDeUnBeneficiario`);
  }

  public BeneficiariosxTitular(fecha_inicio, fecha_final, titular){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?fechainicial=${fecha_inicio}&fechafinal=${fecha_final}&id_titular=${titular}&accion=beneficiariosDeUnTitular`);
  }

  public GuardarTitular(titular){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=guardarTitular&idtit=${titular}`);
  }

  public GuardarBeneficiario(documento, notasIngresoAp, prioridad){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=guardarBeneficiarioPrueba&bendoc=${documento}&notasIngresoAp=${notasIngresoAp}&priap=${prioridad}`);
  }

  public PasarRefuerzo(documento, notas){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=pasarRefuerzoPrueba&bendoc=${documento}&notasIngresoRefuerzo=${notas}`);
  }

  public ActualizarBenefTel(documento, telefono){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=Actualizarbentel&bentel=${telefono}&bendoc=${documento}`);
  }

  public ActualizarBenefCel(documento, celular){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=Actualizarbencel&bencel=${celular}&bendoc=${documento}`);
  }

  public GuardarSeguimiento(apoyo, nota){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=guardarSeguimientoPrueba&id=${apoyo}&seguimiento=${nota}`);
  }

  public CrearAuditoriaBeneficiarios(documento, apoyo){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=crearAuditoriaBeneficiario&bendoc=${documento}&apoyo_id=${apoyo}`);
  }

  public InformacionBeneficiario(documento){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=informacionBeneficiario&bendoc=${documento}`);
  }

  public SeguimientoBeneficiario(documento){
    return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?accion=seguimientoBeneficiario&bendoc=${documento}`);
  }

  /* 
   informe_titulares
  */

 public ApoyoUsuariosTitulares(fecha_inicio, fecha_final) {
  return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?fechainicial=${fecha_inicio}&fechafinal=${fecha_final}&accion=totalServiciosTitulares`);
 }
 
 public BeneficiariosdeunTitular(fechaInicial,fechaFinal,titular_doc) {
  return this._http.get(`${environment.informesdUrl}/controllers/informes_controller.php?fechainicial=${fechaInicial}&fechafinal=${fechaFinal}&id_titular=${titular_doc}&accion=beneficiariosDeUnTitular`);
 }

 /*
  Cartera
*/

public GuardarCobro(cobro: any){
  return this._http.post(`${environment.backendUrl}/controllers/cartera_controller.php?accion=guardarCobro`, cobro);
}

  public serviciosRequiredsByTratamiento(tratamiento:string,fecha1:string,fecha2:string){
    return this._http.get(`${environment.api}vital/servicios/${tratamiento}/${fecha1}/${fecha2}/required`)
  }
  public serviciosObservedByTratamiento(tratamiento:string,fecha1:string,fecha2:string){
    return this._http.get(`${environment.api}vital/servicios/${tratamiento}/${fecha1}/${fecha2}/observed`)
  }
  /**
   * Apunta al endpoint que se encarga de actualizar la observacion de un servicio
   */
  public setAuditObservation(csc,flag,observacion){
    return this._http.put(`${environment.api}vital/servicios/observacionAudit/${csc}`,{
      flag,
      observacion
    })
  }

  public setAuditCaseState(csc,flag,state){
    return this._http.put(`${environment.api}vital/servicios/case-state/${csc}`,{
      flag,
      state
    })
  }

  public servicesIassSeguimiento(fecha1,fecha2){
    this._http.get(`${environment.api}vital/servicios/iass/seguimiento/${fecha1}/${fecha2}`)
  }

  serviciosByTratamiento(tratamiento,fecha1,fecha2){
    return this._http.get(`${environment.api}vital/servicios/${tratamiento}/${fecha1}/${fecha2}`)
  }
  
  public setRequired(csc,flag,state){
    return this._http.put(`${environment.api}vital/servicios/iass/seguimiento/${csc}`,{
      flag,
      state
    })
  }

  public setObservation(csc,flag,observacion){
    return this._http.put(`${environment.api}vital/servicios/iass/observation/${csc}`,{
      flag,
      observacion
    })
  }
  
  public VerNuevosIngresosTitulares(fecha_inicio, fecha_final){
    return this._http.get(`${environment.api}cartera/gestion-titulares-nuevos/${fecha_inicio}/${fecha_final}`);
  }

  public VerNuevosIngresosBenef(fecha_inicio, fecha_final){
    return this._http.get(`${environment.api}cartera/gestion-beneficiarios-nuevos/${fecha_inicio}/${fecha_final}`);
  }
  public informeCovid(body){
    return this._http.post(`${environment.api}covid/informe`,body)
  }

  actualizarGenericField(field,value){
    return this._http.put(`${environment.api}covid/field/${field}`,{
      value:value
    })
  }
  actualizarTitPositivo(csc,value){
    return this._http.put(`${environment.api}covid/positivo/${csc}`,{
      value:value
    })
  }

  updateFiebre(csc,fiebre,temperatura){
    let usuario = JSON.parse(localStorage.getItem("usuario")).nombre
    return this._http.put(`${environment.api}covid/fiebre/${csc}`,{
      fiebre:+fiebre,
      temperatura: +temperatura,
      usuario
    })
  }
  updateRinorrea(csc,rinorrea,color){
    return this._http.put(`${environment.api}covid/rinorrea/${csc}`,{
      fiebre:+rinorrea,
      temperatura: color,
    })
  }

  updateTos(csc,value){
    return this._http.put(`${environment.api}covid/tos/${csc}`,{
      value
    });
  }
  updateDificultadRespiratoria(csc,value){
    return this._http.put(`${environment.api}covid/dificultad-respiratoria/${csc}`,{
      value
    });
  }
  updateObs(csc,value){
    return this._http.put(`${environment.api}covid/obs/${csc}`,{
      value
    });
  }
  updateAtencion(csc,value){
    return this._http.put(`${environment.api}covid/atencion/${csc}`,{
      value
    });
  }
  updateSeguimiento(csc,value){
    return this._http.put(`${environment.api}covid/seguimiento/${csc}`,{
      value
    });
  }

  notificar(csc){
  return this._http.put(`${environment.api}covid/notificar/${csc}`,{

    } )
  }
  informeGestionDeCartera(body):Observable<Array<UsuarioConLlamadas>>{
    return this._http.get<Array<UsuarioConLlamadas>>(`${environment.api}cartera/gestionar/${body.fechaInicio}/${body.fechaFinal}`)
  }
}